import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "../axios";

const useEditSeller = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (params) => {
      const response = await axios.put(
        `/api/sellerprofile/bop?_id=${params._id}`,
        {
          first_name: params.first_name,
          surname: params.surname,
          verify: params.verify,
        },
        // {
        //   params: {
        //     _id: params.id,
        //   },
        // }
      );
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["seller"] });
      queryClient.invalidateQueries({ queryKey: ["sellers"] });
      queryClient.invalidateQueries({ queryKey: ["sellers-2"] });
      queryClient.invalidateQueries({ queryKey: ["sellers-3"] });
    },
    onError: (error) => {
      console.error("Update status error:", error.response?.data || error.message);
    },
  });
  

  return mutation;
};

export default useEditSeller;
